import { useContainer } from '../../useContainer';
import { ProjectApi, ToastStateHandler } from '../../../api';
import { useTranslation } from '../../useTranslation';
import { ICallback } from '../../../commonTypes/hook.types';

const useHttpDeleteProjectAssignee = () => {
    const projectApi: ProjectApi = useContainer(ProjectApi);
    const toastHandler = useContainer(ToastStateHandler);
    const { t } = useTranslation('newNotifications');

    const execDelete = (userSub: string, projectId: string, callback: ICallback) => {
        const { exec, abort } = projectApi.deleteProjectAssignee({
            params: { userSub, id: projectId },
            onSuccess: _ => {
                toastHandler.push('success', t('projects.deleteAssigneeTitle'), t('projects.deleteAssigneMessage_Success'));
                if (callback.onSuccess) callback.onSuccess();
            },
            onError: error => {
                if (error.includes('last'))
                    toastHandler.push('error', t('projects.deleteAssigneeTitle'), t('projects.deleteAssigneMessage_FailedLastManager'));
                if (error.includes('access'))
                    toastHandler.push('error', t('projects.deleteAssigneeTitle'), t('projects.deleteAssigneMessage_FailedNoPesmission'));
            },
        });
        exec();
        return abort;
    };

    return { execDelete };
};

export default useHttpDeleteProjectAssignee;
